import { openInNewTab } from './utils';
import { ProviderType } from '../enums/ProviderType';

export const openGamePlethora = (url, lang) => {
    const langUpper = lang ? lang.toUpperCase() : '';
    const linkWithLang = url && langUpper ? `${url}${langUpper}` : url;
    openInNewTab(linkWithLang);
};

    const openGameIcode = (url, lang) => {
        const linkWithLang = url ? `${url}${lang}` : url;
        openInNewTab(linkWithLang);
};

const providerOpenHandlers = {
    [ProviderType.plethora]: openGamePlethora,
    // [ProviderType.icode]: openGameIcode,
};

export const openGameByProvider = (provider, lang) => {
    const handler = providerOpenHandlers[provider?.name];
    if (handler)
        handler(provider?.url, lang);
    else
        openInNewTab(provider?.url);
};
